import ScrollView from 'devextreme-react/scroll-view';
import React from 'react';
import styles from "./HocSinhProfileListTab.module.css"
import clsx from "clsx"
import { useCommonContext } from '../../../contexts/common';

export const hocSinhProfileTabs = [
    { id: "profile", name: "Thông tin học sinh", icon: "fas fa-id-card-alt", description: "Định nghĩa thông tin đăng ký, địa chỉ, người liên hệ , ..." },
    { id: "familly", name: "Quan hệ gia đình", icon: "fas fa-user-friends", description: "Định nghĩa thông tin bố, mẹ, người giám hộ, ..." },
    { id: "document", name: "Hồ sơ, giấy tờ", icon: "fas fa-book", description: "Các giấy tờ, hồ sơ đã nộp" },
    { id: "discount", name: "Ưu đãi", icon: "fas fa-user-shield", description: "Chọn thông tin ưu đãi" },
    { id: "service", name: "Dịch vụ", icon: "fas fa-ellipsis-v", description: "Các dịch vụ học sinh đăng ký" },
    { id: "saleset", name: "Báo phí", icon: "fa fa-calculator", description: "Tính báo phí các khoản đăng ký" },

    // { id: "care", name: "Lịch sử CSKH", icon: "fas fa-phone", description: "Lịch sử chăm sóc khách hàng của học sinh" },
]

const HocSinhProfileTab = ({ tab, isSelected, onTabSelectionChanged }) => {

    const { translate } = useCommonContext();
    return (
        <div className={clsx(styles.tab_container, isSelected ? styles.selected : "")} onClick={() => {
            onTabSelectionChanged(tab.id)
        }}>
            <div className={styles.tab_icon}>
                <i className={tab.icon}></i>
            </div>
            <div className={styles.tab_text}>
                <p className={styles.name}> {translate(tab.name)}</p>
                <p className={styles.desription}>{translate(tab.description)}</p>
            </div>
        </div>
    );
}

const HocSinhProfileListTab = ({ selectedTab, height, onTabSelectionChanged, hocSinhId }) => {
    return (
        <div className={styles.tab_list_container}>
            <ScrollView>
                {hocSinhProfileTabs.filter(x => hocSinhId > 0 || x.id == "profile").map((x, idx) => {
                    return (
                        <HocSinhProfileTab
                            key={idx}
                            tab={x}
                            onTabSelectionChanged={onTabSelectionChanged}
                            isSelected={x.id == selectedTab}
                        />
                    )
                })}
            </ScrollView>
        </div>
    );
};

export default HocSinhProfileListTab;